import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[rxBadgeIcon]',
})
export class RxBadgeIconDirective implements AfterViewInit {
  @Input() public rxBadgeIcon: string;
  @Input() public matBadgeHidden: boolean = false;

  constructor(private el: ElementRef) {}

  public ngAfterViewInit(): void {
    const isBelow = [...this.el.nativeElement.classList].includes('mat-badge-below');
    const isAfter = [...this.el.nativeElement.classList].includes('mat-badge-after');
    if (!this.matBadgeHidden) {
      const badge = this.el.nativeElement.querySelector('.mat-badge-content');
      if (isBelow && isAfter) {
        badge.style.right = '-5px';
        badge.style.bottom = '-8px';
      }
      badge.style.backgroundColor = 'transparent';
      badge.style.display = 'flex';
      badge.style.alignItems = 'center';
      badge.style.justifyContent = 'center';
      badge.innerHTML = `<img src="assets/icons/${this.rxBadgeIcon}.svg" />`;
    }
  }
}
